<div [id]="'reveal-'+id" class="skv-reveal" data-js-reveal>
    <header class="skv-reveal__header" data-js-reveal-header>
        <h3 class="skv-reveal__title">{{title}}</h3>
        <button class="skv-reveal__toggle" [attr.aria-label]="title" aria-controls="1321" aria-expanded="false" data-js-reveal-trigger>
            <span class="skv-reveal__toggle-text skv-reveal__toggle-text--close">Dölj</span>
            <span class="skv-reveal__toggle-text skv-reveal__toggle-text--open">Visa</span>
            <span class="skv-reveal__toggle-icon">

                <svg focusable="false" class="skv-icon">
                    <use xlink:href="#icon-expand-more"></use>
                </svg>
            </span>
        </button>
    </header>
    <div class="skv-reveal__content-wrapper" id="1321" tabindex="-1" data-js-reveal-container>
        <div class="skv-reveal__content">
            <ng-content></ng-content>
            <div class="skv-reveal__content-toggle">
                <button class="skv-reveal__toggle" aria-label="Dölj" aria-controls="1321" aria-expanded="false" data-js-reveal-trigger>
                    <span class="skv-reveal__toggle-text">Dölj</span>
                    <span class="skv-reveal__toggle-icon">

                        <svg focusable="false" class="skv-icon">
                            <use xlink:href="#icon-expand-more"></use>
                        </svg>
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>